import { Component } from '@angular/core';

@Component({
  selector: 'app-registereduserlanding',
  templateUrl: './registereduserlanding.component.html',
  styleUrl: './registereduserlanding.component.scss'
})
export class RegistereduserlandingComponent {

}
